import { defu } from 'defu'

// @TODO check
// const productPagesCategories = new Map ([
//   ['PageProductOnlinePayments', []]
// ])

// Always add 'min' and 'navigation' categories
const mainDataCategories = new Map([
  ['PageAbout', ['global-offices']],
  ['PagePartnerMerchant', ['partner-labels']],
  ['PagePartners', ['partner-labels', 'filter-labels']],
  ['PagePartnersDetail', ['partner-labels', 'partners']],
  ['PagePartnersOverview', ['partner-labels', 'filter-labels', 'partners']], // languaCollectionData, industryCollectionData,
  ['PageCharities', ['charity-labels', 'charity-sdgs', 'charities', 'filter-labels']],
  ['PageCharitiesDetail', ['charity-labels', 'charity-sdgs', 'charities']],
  ['PageLegal', ['legal-labels']],
  ['PageLegalDetail', ['legal-labels']],
  ['PagePoliciesAndDisclaimer', ['legal-labels']],
  ['PagePoliciesAndDisclaimerDetail', ['legal-labels']],
  ['PageIndustryOverview', []],
  ['PageIndex', ['filter-labels']],
  ['PageLanding', []],
  ['PageIndexIndustryGated', ['filter-labels', 'global-forms', 'form-labels']],
  ['PageIndexIndustryUngated', ['filter-labels']],
  ['PageIndexPrevious', []],
  ['PageIndex2025', ['global-forms', 'form-labels']],
  ['PageIndexChapter2025', ['global-forms', 'form-labels']],
  ['PageIndexSubIndustry', ['global-forms', 'form-labels']],
  ['PageFinancialCapital', ['global-forms', 'form-labels']],
  ['PageFinancialAccounts', ['global-forms', 'form-labels']],
  [
    'PageProductUpdates',
    ['product-updates', 'product-updates-product', 'global-business-type', 'global-forms', 'form-labels']
  ],
  [
    'PageProductUpdatesDetail',
    ['product-updates-product', 'global-business-type', 'product-updates-labels', 'global-forms', 'form-labels']
  ],
  ['PageContactDetail', ['global-forms', 'form-labels', 'filter-labels']],
  ['PageInfrastructure', ['legal-labels']],
  ['PageLicenses', ['legal-labels']],
  ['PageLicenseDetail', ['legal-labels']],
  ['PagePrivacyPolicy', ['legal-labels']],
  ['PagePrivacyPolicyDetail', ['legal-labels']],
  ['PageOffices', ['global-offices']],
  ['PagePlatformDirectory', ['platform-directory']],
  ['PageTerminals', ['terminals', 'terminals-labels', 'terminals-specs-labels']],
  ['PageTerminalsComparison', ['terminals', 'terminals-labels', 'terminals-specs-labels']],
  ['PageTerminalsDetail', ['terminals', 'terminals-labels', 'terminals-specs-labels', 'form-labels']],
  ['PageNewsletter', ['global-forms', 'form-labels']],
  ['PageNewsletterDetail', ['global-forms', 'form-labels']],
  ['PagePodcastOverview', ['global-forms', 'form-labels']],
  ['PageSignup', ['global-forms', 'form-labels', 'filter-labels']],
  ['PageEventsDetail', ['global-forms', 'form-labels', 'events-labels']],
  ['PageSdrSolutionOverview', ['sdr-data']],
  ['PageSdrBusinessCase', ['sdr-data']]
])

const mainApiEndpoints = new Map([
  ['partner-labels', '/api/v3/main_data/partner-labels'],
  ['partners', '/api/v3/main_data/partners'],
  ['charities', '/api/v3/main_data/charities'],
  ['charity-labels', '/api/v3/main_data/charity-labels'],
  ['charity-sdgs', '/api/v3/main_data/charity-sdgs'],
  ['legal-labels', '/api/v3/main_data/legal-labels'],
  ['product-updates-labels', '/api/v3/main_data/product-updates-labels'],
  ['product-updates-latest', '/api/v3/main_data/product-updates-latest'],
  ['product-updates', '/api/v3/main_data/product-updates'],
  ['product-updates-product', '/api/v3/main_data/product-updates-product'],
  ['platform-directory', '/api/v3/main_data/platform-directory'],
  ['terminals', '/api/v3/main_data/terminals'],
  ['terminals-labels', '/api/v3/main_data/terminals-labels'],
  ['terminals-specs-labels', '/api/v3/main_data/terminals-specs-labels'],
  ['events-labels', '/api/v3/main_data/events-labels'],
  ['sdr-data', '/api/v3/main_data/sdr']
])

export const useMainGlobalData = () => {
  const {
    labels,
    globalContentData,
    localeGlobalContentData,
    setGlobalContentData,
    generateDataPromisesForContentType
  } = useGlobalData()

  async function fetchGlobalDataForContentType(contentType: string, locale?: string) {
    const promises = generateDataPromisesForContentType(contentType, mainDataCategories, mainApiEndpoints, locale)
    const response = await Promise.all(promises)

    let data = {}
    response.forEach((r: any) => {
      data = defu(r, data)
    })

    setGlobalContentData(data)
  }

  return {
    labels,
    globalContentData,
    localeGlobalContentData,
    fetchGlobalDataForContentType
  }
}
